﻿
// Auto generated by typewriter


export class SimpleViewModel {
    
    id: number = 0;
    name: string = null;
}
